import { GetJobsiteConfigZonesQuery } from 'apollo/generated/client-operations';
import { Section } from 'components/section';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ZoneDetailsDrawer, ZoneList } from './zones';

type ZoneSummary = NonNullable<
  GetJobsiteConfigZonesQuery['getJobsite']
>['zones'][number];

export function ZonesPanel({
  zones,
}: {
  zones: ZoneSummary[];
}): React.ReactElement {
  const history = useHistory();
  const location = useLocation();
  const selectedZoneId = React.useMemo(
    () => new URLSearchParams(location.search).get('zoneId'),
    [location.search],
  );
  const setSelectedZoneId = React.useCallback(
    (zoneId: string | null) => {
      const searchParams = new URLSearchParams(location.search);
      if (zoneId) searchParams.set('zoneId', zoneId);
      else searchParams.delete('zoneId');
      const nextLocation = {
        pathname: location.pathname,
        search: searchParams.toString(),
      };
      if (zoneId) history.push(nextLocation);
      else history.replace(nextLocation);
    },
    [history, location.pathname, location.search],
  );

  return (
    <>
      <Section
        id="zones"
        title="Zones"
        details="View the physical access areas configured for this site."
        className="odin-border-t odin-border-gray-200"
      >
        <div className="odin-col-span-6">
          <ZoneList
            zones={zones}
            onSelect={(zone) => setSelectedZoneId(zone.id)}
          />
        </div>
      </Section>
      <ZoneDetailsDrawer
        zoneId={selectedZoneId}
        onClose={() => setSelectedZoneId(null)}
      />
    </>
  );
}
